import { Icons } from '@/utils/Icons';
import { useTheme } from '@/hooks/useTheme';

/** Header button that switches the V2 UI between dark and light. */
const ThemeToggle = ({ className = '' }: { className?: string }) => {
  const { theme, toggleTheme } = useTheme();
  const label = theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={label}
      aria-label={label}
      className={`flex size-9 shrink-0 items-center justify-center rounded-md border border-shell-border text-shell-muted transition hover:border-gold hover:text-shell-fg ${className}`}
    >
      {theme === 'dark' ? <Icons.Sun /> : <Icons.Moon />}
    </button>
  );
};

export default ThemeToggle;
